import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// Handles the Emergent OAuth redirect: exchanges session_id (URL fragment) for a session.
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { completeOAuth } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) { navigate("/login"); return; }
    (async () => {
      try {
        await completeOAuth(sessionId);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      } catch (e) {
        setError("Sign-in failed. Please try again.");
        setTimeout(() => navigate("/login"), 1500);
      }
    })();
  }, [location, completeOAuth, navigate]);

  return (
    <div className="min-h-screen grid place-items-center">
      <div className="text-center">
        <div className="h-10 w-10 mx-auto rounded-full border-2 border-[hsl(var(--accent))] border-t-transparent animate-spin" />
        <p className="mt-4 text-sm text-[hsl(var(--muted-foreground))]">{error || "Signing you in…"}</p>
      </div>
    </div>
  );
}
